import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/logo.svg";
import Loader from "./Loader";
import axiosInstance from "../axios/axios";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // Ensure correct state type

  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole") || "user"; // Define userRole

  const handleReset = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Email is required.");
      return;
    }

    setLoading(true);
    try {
      await axiosInstance.post("/resetPassword", { email });
      navigate("/reset-message");
    } catch (err) {
      setError("Failed to send reset email. Try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="flex items-center justify-center min-h-screen h-full custom-bg flex-col w-full py-4">
      <div>You want to sign up as a {userRole}</div>
      <div className="form-container bg-white md:px-[141px] px-[32px] py-[48px] rounded-lg shadow-lg">
        <img src={logo} className="mb-[24px]" alt="Logo" />
        <span className="custom-title mb-[14px] text-xl font-bold">
          Reset Password
        </span>
        <span className="text-sm text-gray-600 mb-[24px] block max-w-[360px] text-center">
          Enter your email address and we will send you instructions for
          password recovery.
        </span>

        <form onSubmit={handleReset} className="flex flex-col gap-4 w-full">
          {error && <p className="text-red-500">{error}</p>}
          <div className="flex flex-col w-full">
            <label htmlFor="email" className="form-label text-sm font-medium">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border rounded-md px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your email"
            />
          </div>
          <button type="submit" className="btn btn-success">
            Reset Password
          </button>
        </form>

        <div className="text-gray-400 flex gap-1 text-center w-full justify-center mt-4">
          Back to
          <NavLink className="text-danger hover:underline" to="/login">
            Log in
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
